<template>
  <div class="app-warp">
    <component :is="!isMbile()?'PcLogIn':'H5LogIn'"></component>
  </div>
</template>
<script>
// @ is an alias to /src
import PcLogIn from "@/components/PC/login.vue";
import H5LogIn from "@/components/H5/login.vue";

export default {
  name: "Home",
  components: {
    PcLogIn,
    H5LogIn
  },
  methods: {
    isMbile: () => {
      const userAgentInfo = navigator.userAgent;
      const Agents = [
        "Android",
        "iPhone",
        "SymbianOS",
        "Windows Phone",
        "iPad",
        "iPod"
      ];
      let isMbile = false;
      for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
          isMbile = true;
          break;
        }
      }
      return isMbile;
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@css/style.scss";

</style>
